(() => {
  const STORAGE_KEY = 'horizon_collection_scroll';
  const COLLECTION_PATH = '/collections/';

  // Only run on collection pages
  const isCollectionPage = () => {
    return window.location.pathname.startsWith(COLLECTION_PATH);
  };

  // Save the current collection scroll position when opening a product
  const saveScrollPosition = (link) => {
    if (!isCollectionPage()) return;

    const card = link.closest('.product-grid__item');

    if (!card) return;

    const data = {
      url: window.location.href,
      scrollY: window.scrollY,
      cardId: card.id,
      timestamp: Date.now()
    };

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  };

  // Product links are inside Horizon product cards
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.product-card__link');

    if (!link) return;

    saveScrollPosition(link);
  });

  // Restore scroll position when returning to the collection
  const restoreScrollPosition = () => {
    if (!isCollectionPage()) return;

    const saved = sessionStorage.getItem(STORAGE_KEY);

    if (!saved) return;

    let data;

    try {
      data = JSON.parse(saved);
    } catch {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    // Don't restore old positions
    if (!data.timestamp || Date.now() - data.timestamp > 30 * 60 * 1000) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    // Only restore for the same collection/filter URL
    if (data.url !== window.location.href) return;

    const restore = () => {
      window.scrollTo({
        top: data.scrollY,
        left: 0,
        behavior: 'instant'
      });
    };

    // First attempt
    restore();

    // Horizon can render/update collection content asynchronously,
    // so try again after the page has settled.
    setTimeout(restore, 100);
    setTimeout(restore, 300);
    setTimeout(restore, 600);
    setTimeout(restore, 1000);

    // Position has been restored
    sessionStorage.removeItem(STORAGE_KEY);
  };

  // Important for browser Back / Forward and bfcache
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      restoreScrollPosition();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreScrollPosition, {
      once: true
    });
  } else {
    restoreScrollPosition();
  }
})();